export enum DataClassification {
  Restricted = "Restricted",
  Unrestricted = "Unrestricted",
  Confidential = "Confidential",
  HighlyConfidential = "Highly Confidential",
}
